var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgRotateRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19 7.41346C4.16222 7.56107 4.19857 7.71352 4.29 7.83279C4.38961 7.96192 4.54709 8.03305 4.71 8.02248H5.71C5.92161 8.02817 6.11387 7.9002 6.19 7.703C6.68105 5.95004 8.08883 4.60289 9.86384 4.18737C11.6389 3.77186 13.4997 4.35387 14.72 5.70621L13.26 7.17385C13.1199 7.31647 13.0785 7.52871 13.1547 7.7134C13.2309 7.8981 13.41 8.01968 13.61 8.02248H17.54C17.8118 8.01223 18.0297 7.79463 18.04 7.52329V3.63953C18.0475 3.43489 17.9266 3.24723 17.7369 3.16926C17.5472 3.09128 17.329 3.1395 17.19 3.29009L16.19 4.28849C14.4387 2.36467 11.7626 1.57034 9.24309 2.22646C6.72355 2.88259 4.77699 4.88073 4.19 7.41346ZM18 10.0193H6C4.89543 10.0193 4 10.9133 4 12.0161V20.0032C4 21.106 4.89543 22 6 22H18C19.1046 22 20 21.106 20 20.0032V12.0161C20 10.9133 19.1046 10.0193 18 10.0193ZM18 20.0032H6V12.0161H18V20.0032Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRotateRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rotate-right.0c370360.svg";
export { ForwardRef as ReactComponent };